import React from 'react';
export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: Array<{
    value: string;
    label: string;
  }>;
}
export function Select({
  label,
  error,
  options,
  className = '',
  ...props
}: SelectProps) {
  return <div className="w-full" data-id="element-379">
      {label && <label className="block text-sm font-medium mb-1" style={{
      color: 'var(--nmhl-text-primary)'
    }} data-id="element-380">
          {label}
        </label>}
      <select className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:border-transparent ${error ? 'border-red-500' : 'border-slate-300'} ${className}`} style={{
      '--tw-ring-color': 'var(--nmhl-burgundy)'
    } as React.CSSProperties} {...props} data-id="element-381">
        {options.map(option => <option key={option.value} value={option.value} data-id="element-382">
            {option.label}
          </option>)}
      </select>
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-383">{error}</p>}
    </div>;
}